import get from 'lodash.get';
import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { PAGE_SIZE } from '~/modules/common/const';

export const PROJECT_DROPDOWN_QUERY = gql`
  query ProjectDropdownSearch(
    $page: Int!
    $pagesize: Int!
    $projectFilter: ProjectFilter2
  ) {
    projects(page: $page, pagesize: $pagesize, projectFilter: $projectFilter) {
      id
      displayText
    }
  }
`;

export const PAGE_OF_PROJECTS_AVAILABLE_FOR_RESOURCE_ALLOCATION_CREATION_QUERY = gql`
  query PageOfProjectsAvailableForResourceAllocationCreationSearch(
    $page: Int!
    $pagesize: Int!
    $filter: PageOfProjectsAvailableForResourceAllocationCreationFilter
  ) {
    pageOfProjectsAvailableForResourceAllocationCreation(
      page: $page
      pagesize: $pagesize
      filter: $filter
    ) {
      id
      displayText
    }
  }
`;

const useProjectDropdownSearch = ({
  searchTerm,
  excludeProjectStatus,
  skip
}) => {
  const { data, loading } = useQuery(PROJECT_DROPDOWN_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      page: 1,
      pagesize: PAGE_SIZE + 1,
      projectFilter: {
        text: searchTerm,
        excludeProjectStatus
      }
    },
    context: {
      debounceKey: 'project-search',
      debounceTimeout: 250
    },
    skip
  });

  return {
    projects: loading ? [] : get(data, 'projects', []),
    loading
  };
};

const usePageOfProjectsAvailableForResourceAllocationCreationSearch = ({
  searchTerm,
  skip
}) => {
  const { data, loading } = useQuery(
    PAGE_OF_PROJECTS_AVAILABLE_FOR_RESOURCE_ALLOCATION_CREATION_QUERY,
    {
      fetchPolicy: 'network-only',
      variables: {
        page: 1,
        pagesize: PAGE_SIZE + 1,
        filter: {
          textSearch: searchTerm
        }
      },
      context: {
        debounceKey: 'project-search',
        debounceTimeout: 250
      },
      skip
    }
  );

  return {
    projects: loading
      ? []
      : get(data, 'pageOfProjectsAvailableForResourceAllocationCreation', []),
    loading
  };
};

export const useProjectDropdownOptionsWithStatusFilter = ({
  searchTerm,
  excludeProjectStatus,
  skip = false,
  usePageOfProjectsAvailableForResourceAllocationCreationQuery = false
}) => {
  const projectDropdown = useProjectDropdownSearch({
    searchTerm,
    excludeProjectStatus,
    skip: skip || usePageOfProjectsAvailableForResourceAllocationCreationQuery
  });

  const pageOfProjectsAvailableForResourceAllocationCreation = usePageOfProjectsAvailableForResourceAllocationCreationSearch(
    {
      searchTerm,
      skip:
        skip || !usePageOfProjectsAvailableForResourceAllocationCreationQuery
    }
  );

  const {
    projects,
    loading
  } = usePageOfProjectsAvailableForResourceAllocationCreationQuery
    ? pageOfProjectsAvailableForResourceAllocationCreation
    : projectDropdown;

  return {
    projects,
    loading,
    hasMore: projects.length > PAGE_SIZE
  };
};

export default useProjectDropdownOptionsWithStatusFilter;
